import { css } from '@emotion/react';
import { Modal, NavigationRow, Type } from '@robinhood/design';

import Button from 'src/components/creditApplication/Button';

const RobinhoodGoldCardPrivacyPolicyUrl = 'https://robinhood.com/us/en/support/articles/privacy-policy/';
const CoastalCommunityBankPrivacyPolicyUrl = 'https://www.coastalbank.com/privacy-center/';
const RobinhoodGoldCardGLBANoticeUrl = 'https://api.robinhood.com/creditcard/legal/privacy/';

interface PropsIface {
  onDismiss: () => void;
}

// TODO (szhang): investigate Modal padding issue
const PrivacyNoticeModal = ({ onDismiss }: PropsIface) => {
  return (
    <Modal width='wide' overrideModalStyles={root} onClose={onDismiss}>
      <Type.Display size='S' overrideRootStyles={{ textAlign: 'center' }}>
        Privacy policies and GLBA notice
      </Type.Display>
      <div css={linksContainer}>
        <NavigationRow
          title='Robinhood Gold Card Privacy Policy'
          action='link'
          href={RobinhoodGoldCardPrivacyPolicyUrl}
          newTab
        />
        <NavigationRow
          title='Coastal Community Bank Privacy Policy'
          action='link'
          href={CoastalCommunityBankPrivacyPolicyUrl}
          newTab
        />
        <NavigationRow
          title='Robinhood Gold Card GLBA Notice'
          action='link'
          href={RobinhoodGoldCardGLBANoticeUrl}
          newTab
        />
      </div>
      <Button label='Dismiss' width='full' type='button' onClick={onDismiss} />
    </Modal>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
`;

const linksContainer = css`
  width: 100%;
`;

export default PrivacyNoticeModal;
